import React, { useState, useRef } from "react";
import "./MobileViaPhone.css";
import backArrow from "../../img/back-arrow.svg";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { fetchUserAsync, selectUser } from "../../features/auth/authSlice";
import { useDispatch,useSelector } from "react-redux";

import MobilePhoneAndEmailChange from "./MobilePhoneAndEmailChange";
import toast from "react-hot-toast";

function MobileViaPhone({ handleBackClick, phoneNumber, verify, setVerify }) {
  const dispatch = useDispatch();
  const userDetail = useSelector(selectUser);
  const [otpInputs, setOtpInputs] = useState(["", "", ""]);
  const [open, setOpen] = useState(false);
  const inputRefs = useRef([...Array(2)].map(() => React.createRef()));

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const handleVerify = async () => {
    handleOpen();
    const enteredOTP = otpInputs.join("");
    if (!enteredOTP || enteredOTP.length < 6) {
      handleClose();
      toast.error('Enter OTP correctly')
    } else {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}update_verify_otp/${userDetail?.UserID}/${enteredOTP}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();
        if (response.ok) {
          dispatch(fetchUserAsync(userDetail?.UserID));
          handleClose();

          setVerify(true);
        } else {
          handleClose();
          // console.error("API request failed:", response.statusText);
          toast.error('Invalid OTP');
        }
      } catch (error) {
        handleClose();
        // console.error(
        //   "An error occurred during the API request:",
        //   error.message
        // );
      }
    }
  };

  const handleInputChange = (index, event) => {
    const value = event.target.value;
    if (value.length <= 3) {
      const newOtpInputs = [...otpInputs];
      newOtpInputs[index] = value;
      setOtpInputs(newOtpInputs);
      if (value.length === 3 && index === 0) {
        inputRefs.current[1].current.focus();
      }
    }
  };

  return (
    <div className="mobile-via-phone-verification-via-sms-container">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <img loading="lazy" className="mobile-back-a-arrow" src={backArrow} alt="" onClick={handleBackClick} />
      {verify ? (
        // <div className="verification-phone-email-verified">
        //   <CheckOutlinedIcon/>
        //   <span>Verified successfully</span>
        // </div>
        <div className="via-phone-phone-email-change-container">
          <MobilePhoneAndEmailChange />
        </div>
      ) : (
        <>
          <h3 className="mobile-via-phone-heading">Verification via sms</h3>
          <span className="mobile-via-phone-otp">We have sent an OTP to the phone number</span>
          <span className="mobile-via-phone-below">Please enter it below</span>
          <div className="mobile-via-phone-vefification-via-sms-input-div">
            <input
              ref={inputRefs.current[0]}
              type="text"
              onKeyPress={(e) => {
                // Allow only numbers (0-9) and backspace (8)
                if (!/[0-9\b]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              maxLength={3}
              placeholder="X X X"
              value={otpInputs[0]}
              onChange={(e) => handleInputChange(0, e)}
            />

            <span className="mobile-via-phone-otp-divider">-</span>
            <input
              ref={inputRefs.current[1]}
              type="text"
              onKeyPress={(e) => {
                // Allow only numbers (0-9) and backspace (8)
                if (!/[0-9\b]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              maxLength={3}
              placeholder="X X X"
              value={otpInputs[1]}
              onChange={(e) => handleInputChange(1, e)}
            />
          </div>
          <span className="mobile-via-phone-verify-otp-btn" onClick={handleVerify}>
            Verify
          </span>
        </>
      )}
    </div>
  );
}

export default MobileViaPhone;
